
  import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
  @Component({
    components: {},
    filters:{}
  })
  export default class Test extends Vue {
    
    /// props
    @Prop({ default: '' }) private basePath!: string
  
    @Prop({ default: [] }) public content!: Array<any>
    
    /// data
    private data: Object = {}
    
    /// provide data
    @Provide() provideData: Object = {}
    
    // computed
    private get infos(): Array<any> {
        return Array<any>()
    }
    public currentIndex: any = 1
    public swipChange(index: any) {
      this.currentIndex = index + 1
    }
    public swipChangeIndex(index: any) {
        this.$refs.swipe && (this.$refs.swipe as any).swipeTo((index - 1));
    }
  
    public resize() {
        this.$refs.swipe && (this.$refs.swipe as any).resize();
    }

    private fileIcon(file: any) {
        if(file.filetype == 'pdf') {
            return require("../../assets/icons/icon-file@2x.png")
        }
        if(file.filetype == 'docx' || file.filetype == 'doc') {
            return require("../../assets/icons/icon-world@2x.png")
        }
        if(file.filetype == 'xls' || file.filetype == 'xlsx') {
            return require("../../assets/icons/icon-execl@2x.png")
        }
        if(file.filetype && file.filetype.toLowerCase() == 'zip') {
            return require("../../assets/icons/icon-zip@2x.png")
        }
        return require("../../assets/icons/icon-other@2x.png")
    }
    
    /// lifecycle
    created() {
      
    }
    
    mounted() {
        setTimeout(()=>{
            this.$refs.swipe && (this.$refs.swipe as any).resize();
        }, 1000)
    }
    
    /// methods
    public methodOne(params: any): void {
      
    }
    /// watch methods
    @Watch('newList', { immediate: true, deep: true })
    onArrayChanged(newVal: any, oldVal: any) {
      
    }
  }
  